module.exports = __webpack_public_path__ + "img/HT.1fa85829.svg";